import { FaSave } from 'react-icons/fa';
import SettingsCard from './SettingsCard';
import ToggleControl from './ToggleControl';

const EmergencySection = ({
  emergencyMode,
  onEmergencyModeToggle,
  processingMode,
  onProcessingModeChange,
  onSave,
  hasChanges = false,
}) => (
  <SettingsCard
    title="Emergency"
    description="Control emergency processing behavior for live operations."
  >
    <div className="space-y-5">
      <ToggleControl
        label="Emergency Mode"
        description="Enable emergency mode for urgent event handling."
        checked={emergencyMode}
        onChange={onEmergencyModeToggle}
      />

      <div className="grid gap-2">
        <label
          htmlFor="emergency-processing-mode"
          className="text-sm font-medium dark:text-customHeading text-background"
        >
          Processing Mode
        </label>
        <select
          id="emergency-processing-mode"
          value={processingMode}
          onChange={(event) => onProcessingModeChange(event.target.value)}
          disabled={!emergencyMode}
          className="h-11 w-full rounded-lg border border-customBorder/60 dark:bg-custom_dark_background bg-customLightMilkWhite px-3 text-sm font-semibold dark:text-customHeading text-background outline-none transition focus:border-customAccent focus:ring-2 focus:ring-customAccent/30 disabled:cursor-not-allowed disabled:opacity-60 sm:max-w-xs"
        >
          <option value="auto">Auto</option>
          <option value="manual">Manual</option>
          <option value="oddsManual">Odds Manual</option>
        </select>
      </div>

      <div className="flex justify-end">
        <button
          type="button"
          onClick={onSave}
          disabled={!hasChanges}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-customAccent px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-customAccent/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-customAccent focus-visible:ring-offset-2 focus-visible:ring-offset-customSurface disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-customAccent"
        >
          <FaSave className="h-4 w-4" aria-hidden="true" />
          Save Changes
        </button>
      </div>
    </div>
  </SettingsCard>
);

export default EmergencySection;
